import {Directive, Input, TemplateRef} from "@angular/core";

@Directive({
  selector: 'ng-template[intTabsContent]'
})
export class IntTabsContentDirective {

  @Input() intTabsContent: string | number | null = null;
  constructor(
    readonly templateRef: TemplateRef<any>
  ) {
  }
}
